import React from 'react'
import { buildLayoutConfig, COMMON_LAYOUT_EDITABLE_FIELDS, IntroStatsPanel, LayoutSections } from './layoutShared'

const DEFAULT_CONFIG = {
  heroBackgroundColor: '#111827',
  heroTextColor: '#ffffff',
  heroSubtitleColor: '#cbd5e1',
  formBorderColor: '#0f172a',
  formBorderWidth: 2,
  bodyBackgroundColor: '#f8fafc',
}

function BasicTemplate5Layout({
  mode = 'public',
  heroTitle,
  heroSubtitle,
  heroImageFileId,
  sections = [],
  formEnabled = true,
  introStats = [],
  customConfig = {},
  resolveAssetUrl,
  formCard = null,
  recommendedProductsCard = null,
  previewBanner = null,
  surveyModal = null,
  surveyDoneModal = null,
}) {
  const config = buildLayoutConfig('basic-template-5', customConfig, DEFAULT_CONFIG)
  const isLive = mode === 'live'

  return (
    <div className="min-h-full bg-white text-slate-900">
      {previewBanner}
      <div className="px-4 py-18 md:py-22" style={{ backgroundColor: config.heroBackgroundColor }}>
        <div className={`mx-auto ${isLive ? 'max-w-full space-y-6' : 'max-w-6xl grid grid-cols-1 lg:grid-cols-2 gap-8 items-center'}`}>
          <div>
            {heroTitle && <h1 className="whitespace-pre-line text-5xl md:text-6xl font-extrabold tracking-tight leading-tight" style={{ color: config.heroTextColor }}>{heroTitle}</h1>}
            {heroSubtitle && <p className="mt-5 text-xl md:text-2xl leading-8 whitespace-pre-line" style={{ color: config.heroSubtitleColor }}>{heroSubtitle}</p>}
          </div>
          <div className="flex min-h-[300px] items-center justify-center overflow-hidden rounded-[32px] border border-white/10 bg-white/10 shadow-2xl">
            {heroImageFileId ? (
              <img src={resolveAssetUrl(heroImageFileId)} alt="" className="w-full h-full max-h-[420px] object-cover" />
            ) : (
              <div className="px-6 py-12 text-center text-base leading-7 text-white/60">대표 이미지를 넣으면 보다 강한 첫인상을 줄 수 있습니다.</div>
            )}
          </div>
        </div>
      </div>

      <div className="px-4 py-12 md:py-14" style={{ backgroundColor: config.bodyBackgroundColor }}>
        <div className={`mx-auto ${isLive ? 'max-w-full space-y-4' : 'max-w-6xl grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_360px] gap-8'}`}>
          <div className="space-y-6">
            <IntroStatsPanel introStats={introStats} />
            <LayoutSections sections={sections} resolveAssetUrl={resolveAssetUrl} variant={isLive ? 'compact' : 'default'} />
          </div>

          {(formEnabled || recommendedProductsCard) && (
            <div className={isLive ? 'space-y-3' : 'space-y-3 xl:sticky xl:top-6 self-start'}>
              {recommendedProductsCard}
              {formEnabled && formCard}
            </div>
          )}
        </div>
      </div>

      {surveyModal}
      {surveyDoneModal}
    </div>
  )
}

export const basicTemplate5StyleLayout = {
  key: 'basic-template-5',
  label: '기본 템플릿 5 - 프리미엄 상담형',
  description: '다크 히어로와 우측 고정형 요약 영역을 사용하는 레이아웃입니다.',
  editableConfigFields: [
    ...COMMON_LAYOUT_EDITABLE_FIELDS,
    { key: 'bodyBackgroundColor', label: '본문 배경색', placeholder: '#f8fafc' },
  ],
  normalizeCustomConfig: (customConfig) => buildLayoutConfig('basic-template-5', customConfig, DEFAULT_CONFIG),
  Component: BasicTemplate5Layout,
}
